<template>
  <a-row type="flex">
    <a-col :span="3"></a-col>
    <a-col :span="4" class="contact_page_title">Contact Us</a-col>
    <a-col :span="17"></a-col>
  </a-row>
  <a-row>
    <a-col :span="3"></a-col>
    <a-col :span="7">
      <div class="contact_page_text">
        <br/>
        <p style="color: black; font-size: 26px; margin-bottom: 1vh;font-weight: bold">CONTACT US</p>
        <p>Headquartered in the US, SIG is a global proprietary trading and
          broker-dealer firm founded with an
          entrepreneurial mindset</p>
        <p>and a rigorous analytical approach to decision making.</p>
        <p>Over the past 30 years, SIG's business thrives at the intersection of
          trading, quantitative research, and
          technology.</p>
        <p>SIG now has over 2,500 employees worldwide.</p>
        <p></p>
        <p style="margin-top: 20px;font-size: 16px">Shanghai address</p>
        <p>Suite 1705-11, 1 Corporate Avenue, 222 Hu Bin Road, Huangpu District, Shanghai 200021</p>
        <p>Tel: (+86) 21-61222888</p>
        <p style="margin-top: 20px;font-size: 16px">Beijing address</p>
        <p>Suite 1908, East Tower, Twin Towers, B-12 Jianguomenwai Avenue, Chaoyang District, Beijing 100022</p>
        <p>Tel: (+86) 10-65665096</p>
        <br/>
      </div>
    </a-col>
    <a-col :span="11"><img src="../../../assets/image/map_en.png" style="width: 45.8vw"></a-col>
  </a-row>

  <Footer></Footer>


</template>
<script>
import Footer from "@/components/CN/Footer";

export default {
  name: 'Contact_page_en',
  components: {
    Footer,
  },
}
</script>
<style scoped>
.contact_page_title {
  background: #2f54eb;
  color: white;
  font-size: 18px;
  text-align: left;
  line-height: 40px;
  padding-left: 2vh;
  text-indent: 2em;
}

.contact_page_text p {
  color: grey;
  margin-bottom: 0;
  font-size: 14px;
}

.contact_page_text {
  text-align: left;
  padding-left: 1vw;
  padding-top: 2vh;
}
</style>
